export default __webpack_public_path__ + "static/media/frg--gymnasium.89c655ec.png";